import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type ObservableDocumentModel from 'tio-common/models/observable-document';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';

type RouteParams = {
  observable_document_id: number;
};

export default class AuthenticatedObservabilityDocumentsShow extends Route {
  @service declare store: StoreService;

  async model(params: RouteParams) {
    const id = params['observable_document_id'];

    return this.store.findRecord<ObservableDocumentModel>('observable-document', id, {
      include: 'observable-asset,observable-document-logs',
    });
  }
}
